import './App.css';
import CardGame from './components/CardGame';

function App() {
  return (
    <div className="App">
      <CardGame />
    </div>
  );
}

export default App;
